import { createActions } from 'reduxsauce';

var _createActions = createActions({
  sortByChange: function sortByChange(json) {
    return {
      type: 'SEARCH_SORT_BY_CHANGE',
      sortBy: json.sortBy
    };
  },
  pageChange: function pageChange(json) {
    return {
      type: 'SEARCH_PAGE_CHANGE',
      currentPage: json.currentPage
    };
  },
  termChange: function termChange(json) {
    return {
      type: 'SEARCH_TERM_CHANGE',
      searchTerm: json.searchTerm
    };
  },
  pageSizeChange: function pageSizeChange(json) {
    return {
      type: 'SEARCH_PAGE_SIZE_CHANGE',
      pageSize: json.pageSize
    };
  },
  topicsChange: function topicsChange(json) {
    return {
      type: 'SEARCH_TOPICS_CHANGE',
      topics: json.topics,
      currentPage: 0
    };
  },
  categoriesChange: function categoriesChange(json) {
    return {
      type: 'SEARCH_CATEGORIES_CHANGE',
      categories: json.categories,
      currentPage: 0
    };
  },
  priceChange: function priceChange(json) {
    return {
      type: 'SEARCH_PRICE_CHANGE',
      price: json.price,
      currentPage: 0
    };
  },
  dataSourceChange: function dataSourceChange(json) {
    return {
      type: 'SEARCH_DATA_SOURCE_CHANGE',
      dataSource: json.dataSource
    };
  },
  sortChange: function sortChange(json) {
    return {
      type: 'SEARCH_SORT_CHANGE',
      order: json.order,
      sortBy: json.sortBy
    };
  },
  request: function request() {
    return {
      type: 'SEARCH_REQUEST'
    };
  },
  response: function response(json) {
    return {
      type: 'SEARCH_RESPONSE',
      searchResults: json.Items,
      totalSearch: json.TotalResults,
      facets: json.Facets
    };
  },
  clearRail: function clearRail() {
    return {
      type: 'SEARCH_CLEAR_RAIL'
    };
  }
}, {
  prefix: 'SEARCH_'
}),
    Creators = _createActions.Creators,
    Types = _createActions.Types;

export default {
  Creators: Creators,
  Types: Types
};